<template>
  <div class="checkout--page__shipping__info--value">
    <template  v-if="type === 'TEXT'">
      <input type="text"
        :name="field_name"
        :value="localValue"
        @change="update_value"
        :placeholder="title"/>
    </template>

    <template  v-if="type === 'DATE'">
      <input type="date" :class="{'empty': !localValue}"
        :name="field_name"
        :value="localValue"
        @change="update_value"
        :placeholder="title"/>
    </template>

    <template v-if="type === 'TEXTAREA'">
      <textarea cols="30" rows="6"
        :name="field_name"
        :value="localValue"
        @change="update_value"
        :placeholder="title">
      </textarea>
    </template>

    <template v-if="type === 'DROPDOWN'">
      <select :class="{'empty': !localValue}"
      :name="field_name"
      :value="localValue"
      @change="update_value">
        <option disabled default value="" selected>{{title}}</option>
        <option v-for="item in data" v-if="item.value && item.name" :value="item.value">{{item.name}}</option>
      </select>
    </template>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  export default {
    props: ['value', 'type', 'name', 'data', 'title', 'repeat'],

    computed: {
      ...mapGetters([
        'fields'
      ]),

      localValue () {
        return this.fields[this.name].value || this.value;
      },

      field_name () {
        if (this.repeat) {
          return this.name + '[]';
        }
        return this.name;
      }
    },

    created () {
      this.$emit('input', this.localValue);
    },

    methods: {
      ...mapActions([
        'update_form_field',
      ]),

      update_value (e) {
        this.$emit('input', e.target.value);
        this.update_form_field({
          name: e.target.name,
          value: e.target.value,
        });
      },
    }
  };
</script>

<style scoped>
  .checkout--page__shipping__info--value > * {
    width: 100%;
    border-radius: 0px;
    border: 1px solid #ddd;
    padding: 2%;
    margin-bottom: 5%;
  }

  select {
   -webkit-appearance: none;
   -moz-appearance: none;
    background: none;
    /* height: 4rem; */
    color: black;
    background: white;
  }


  textarea::-webkit-input-placeholder,
  input::-webkit-input-placeholder,
  .empty {
    color: #6C7A89;
  }

  @media screen and (max-width: 767px) {
    select, textarea, input {
        font-size: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// form-item.vue?34612ca6